import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '..'; // 在 store/index.ts 中声明的类型
import { MchInfo } from '../../service/class/MchInfo';

// 借助 createSlice 创建 reducer、action
const SelectMerchantSlice = createSlice({
    name: 'selectMerchant',
    initialState: {
        value: new MchInfo(),
    },
    reducers: {
        setData: (state, action: PayloadAction<MchInfo>) => {
            state.value = action.payload;
        },
    },
});

// Action Creator 用于执行返回描述如何更新 state 的 Action
export const { setData } = SelectMerchantSlice.actions;

export const setSelectMerchantSlice = (data: MchInfo) => (dispatch: AppDispatch) => {
    dispatch(setData(data));
};

// Selector，作为 useSelector 读取数据的函数参数
export const selectMerchantSliceSelector = (state: RootState) => state.selectMerchant.value;

// Reducer，真正执行修改 state 的纯函数
export default SelectMerchantSlice.reducer;
